// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import TimesheetsConfigFormController from "./timesheets/config_form_controller"
application.register("timesheets-config-form", TimesheetsConfigFormController)

import TimesheetsMembershipConfigFormController from "./timesheets/membership_config_form_controller"
application.register("timesheets-membership-config-form", TimesheetsMembershipConfigFormController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

